export default {
  AGREEMENT_REJECTION: 'AGREEMENT_REJECTION',
  AGREEMENT_VIOLATION: 'AGREEMENT_VIOLATION',
  AGREEMENT_UNFULFILLED: 'AGREEMENT_UNFULFILLED',
  BILATERAL: 'BILATERAL',
};
